import React from "react";
import HeroSection from "../components/common/HeroSection";

const TermsOfService = () => {
  return (
    <div>
      {/* <HeroSection
        title="Terms of Service"
        breadcrumb={[{ name: "Terms of Service" }]}
        background="/assets/images/about/bg.png"
      /> */}
      <div className="terms-of-service-page min-h-screen bg-gray-50 py-20 px-4 md:px-8 lg:px-16">
        <div className="container mx-auto max-w-4xl bg-white rounded-lg shadow-lg p-10">
          <h1 className="text-5xl text-center font-extrabold mb-10 text-gray-900 tracking-tight">
          Terms of Service
        </h1>  

          <p className="text-gray-500 mb-16 text-center text-sm uppercase tracking-wide">
            <strong>Last Updated:</strong> 26 September 2025
          </p>

          {[
            {
              title: "1. Definitions",
              content: (
                <>
                  <p className="font-bold text-gray-700 leading-relaxed mb-2">
                    <strong>User / You / Your</strong> means any individual or
                    entity accessing or using the Site.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    <strong>Content</strong> refers to all text, images, data,
                    designs, software, code, audio, video, or other materials
                    made available via the Site.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <strong>Services</strong> refers to any services offered by
                    STISSA Technology LLC (TISSA Technology) through the Site.
                  </p>
                </>
              ),
            },
            {
              title: "2. Eligibility",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    You must be at least 18 years old (or the age of legal
                    majority in your jurisdiction) to use the Site.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    If you are using the Site on behalf of an organization, you
                    represent and warrant that you have authority to bind that
                    organization to these Terms.
                  </p>
                </>
              ),
            },
            {
              title: "3. Use of the Site & Restrictions",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    You agree to use the Site, Content, and Services only for
                    lawful purposes, and in compliance with all applicable laws
                    and regulations.
                  </p>
                  <p className="text-gray-700 mb-3 font-semibold">
                    You must not:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>
                      use the Site in any way that could damage, disable,
                      overburden, or impair it;
                    </li>
                    <li>
                      attempt to gain unauthorized access to any part of the
                      Site, other accounts, systems, or networks;
                    </li>
                    <li>
                      use any automated system (bot, scraper, crawler, etc.) to
                      access the Site without permission;
                    </li>
                    <li>
                      upload, post, transmit any Content that is unlawful,
                      defamatory, fraudulent, infringing, harmful, or otherwise
                      objectionable.
                    </li>
                  </ul>
                </>
              ),
            },
            {
              title: "4. Intellectual Property",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    All Content, trademarks, logos, designs, software, and other
                    intellectual property on the Site are owned by or licensed
                    to STISSA Technology LLC (TISSA Technology), unless otherwise stated.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    You may view or download Content for personal,
                    non‑commercial use only, unless permitted otherwise in
                    writing.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    You must not reproduce, distribute, modify, create
                    derivative works, publicly display, or exploit any of the
                    Site’s intellectual property without express written
                    permission.
                  </p>
                </>
              ),
            },
            {
              title: "6. User‑Generated Content",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    If the Site allows you to submit, post or otherwise make
                    available content (comments, reviews, feedback, etc.), you
                    grant STISSA Technology LLC (TISSA Technology) a non‑exclusive, royalty‑free,
                    worldwide, perpetual right to use, modify, reproduce,
                    distribute, and display such content.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    You represent that you own or have the necessary rights to
                    post such content, and that it does not violate third‑party
                    rights.
                  </p>
                </>
              ),
            },
            {
              title: "7. Disclaimers & “As Is” Basis",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  The Site and all Services are provided on an “as is” and “as
                  available” basis. We make no warranties of any kind, express
                  or implied, regarding the operation of the Site or the
                  information, Content, materials or Services included on or
                  otherwise made available through the Site, including
                  warranties of merchantability, fitness for a particular
                  purpose, non‑infringement, or uninterrupted service.
                </p>
              ),
            },
            {
              title: "8. Limitation of Liability",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    To the maximum extent permitted by applicable law, TISSA
                    Technology shall not be liable for any indirect, incidental,
                    special, consequential, or punitive damages, or any loss of
                    profits or revenues, whether incurred directly or
                    indirectly, or loss of data, use, goodwill, or other
                    intangible losses, resulting from:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>
                      your access to or use of or inability to access or use the
                      Site or Services;
                    </li>
                    <li>
                      any conduct or content of any third party on the Site;
                    </li>
                    <li>any content obtained from the Site;</li>
                    <li>
                      unauthorized access, use or alteration of your
                      transmissions or content.
                    </li>
                  </ul>
                </>
              ),
            },
            {
              title: "9. Changes to Terms",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may revise these Terms from time to time. The revised
                    Terms will take effect on the date they are posted.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Your continued use of the Site after changes are posted
                    constitutes your acceptance of the new Terms.
                  </p>
                </>
              ),
            },
            {
              title: "10. Indemnification",
              content: (
                <>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    You agree to defend, indemnify, and hold harmless TISSA
                    Technology, its affiliates, officers, directors, employees,
                    agents, and licensors from and against any and all claims,
                    damages, obligations, losses, liabilities, costs or debt,
                    and expenses (including but not limited to reasonable legal
                    fees) arising from:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>your use of the Site or Services;</li>
                    <li>your violation of these Terms;</li>
                    <li>your violation of any third‑party rights;</li>
                    <li>your misrepresentation or misconduct.</li>
                  </ul>
                </>
              ),
            },
            {
              title: "11. Severability",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  If any provision of these Terms is found to be invalid,
                  illegal or unenforceable, that provision will be revised to
                  the minimum extent necessary to make it valid, legal and
                  enforceable. The remaining provisions will remain in full
                  force and effect.
                </p>
              ),
            },
            {
              title: "12. Waiver",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  No waiver by us of any breach or default hereunder shall be
                  deemed a waiver of any preceding or subsequent breach.
                </p>
              ),
            },
            {
              title: "13. Entire Agreement",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  These Terms, together with any additional terms, policies, or
                  notices published by us on the Site (including Privacy
                  Policy), constitute the entire agreement between you and TISSA
                  Technology concerning your use of the Site and supersede all
                  prior or contemporaneous agreements or communications.
                </p>
              ),
            },
            {
              title: "14. Contact Information",
              content: (
                <address className="not-italic text-gray-700 space-y-2 leading-relaxed">
                  <p>STISSA Technology LLC (TISSA Technology)</p>
                  <p>
                    Office no. 505, City Avenue, Oppo. Phoenix Mall of the Millennium, 
                    Mumbai-Bangalore Highway, Wakad, Pune 411057
                  </p>
                  <p>
                    Email:{" "}
                    <a
                      href="mailto:connect@tissatech.com"
                      className="text-indigo-600 hover:underline"
                    >
                      connect@tissatech.com
                    </a>
                  </p>
                  <p>
                    Phone:{" "}
                    <a
                      href="tel:+91-9373772429"
                      className="text-indigo-600 hover:underline"
                    >
                      +91-9373772429
                    </a>
                  </p>
                  <p>
                    Website:{" "}
                    <a
                      href="https://tissatech.in"
                      className="text-indigo-600 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://tissatech.in
                    </a>
                  </p>
                </address>
              ),
            },
          ].map(({ title, content }, i) => (
            <section
              key={i}
              className="mb-12 border-b border-gray-200 pb-8 last:border-0 last:pb-0"
            >
              <h2 className="text-3xl font-bold mb-5 text-gray-900 tracking-wide">
                {title}
              </h2>
              {content}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
